<template>
  <div class="relative flex items-center p-5 m-1 bg-gray-100 rounded-md hover:bg-gray-200 group">
    <div class="flex-1 block p-1 -m-1">
      <div class="absolute inset-0 group-hover:bg-gray-100 dark:group-hover:bg-dark-divider" aria-hidden="true" />

      <div class="relative flex items-center flex-1 min-w-0">
        <div v-if="!channel.is_private">
          #
        </div>
        <div v-else>
          <Lock class="w-5 h-5" />
        </div>
        <div class="ml-4 truncate">
          <p class="text-sm font-medium text-gray-900 truncate dark:text-white">
            {{ channel.name }}
          </p>
        </div>
      </div>
    </div>
    <div as="div" class="relative flex-shrink-0 inline-block ml-5 text-left">
      <slot name="actions">
        <SimpleActionDropDown
          :icon="ellipsisVerticalIcon"
          classes="relative flex-shrink-0 top-1"
          dropdown-class="absolute z-50 !w-36 mx-3 mt-1 !-right-6 origin-bottom-right bg-white rounded-md shadow-lg dark:bg-dark-screen-background ring-1 ring-black ring-opacity-5 focus:outline-none"
          item-class="text-gray-700 dark:text-dark-body-text"
          item-active-class="text-gray-400 bg-gray-100 dark:bg-dark-screen-background"
          :icon-button="true"
          :items="dropdownItems" />
      </slot>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue"
import SimpleActionDropDown from "@/components/shared/dropdowns/SimpleActionDropDown.vue"
import { Lock } from "lucide-vue-next"

export default defineComponent({
  name: "ContactCard",
  components: {
    SimpleActionDropDown,
    Lock
  },
  props: {
    channel: {
      type: Object,
      required: true
    },

    ellipsisVerticalIcon: {
      type: Object,
      required: true
    }
  },
  emits: ["removeChannel"],
  setup(props, { emit }) {
    const dropdownItems = computed(() => {
      // Generate dropdown items based on contactType
      let items = []
      items.push({
        name: "Remove",
        action: () => emit("removeChannel", props.channel)
      })
      return items
    })

    return {
      dropdownItems
    }
  }
})
</script>
